import React from 'react';
import styled from 'styled-components';
import { AddButton } from '../../reusableItems/buttons';
import { AddNewTaskMethod } from './addNewTask';
import { SingleAction } from './singleAction';
import { DateTime } from "luxon";

const Wrapper = styled.div`
    position:relative;
    width: 100%;
    height:7rem;
    .line{
        position:absolute;
        top:3.5rem;
        border: var(--lighter-gray) solid;
        border-width: 1px 0 0 0;
        width:100%;
    }
`

const AddNewTaskButton = styled.span`
    position:absolute;
    right:${props => props.$right ? props.$right : 0};
    // right:0rem;
    width:${props => props.$width ? props.$width : 0};
    // z-index:100;
    // top:2.81rem;
    height:100%;
    display:flex;
    justify-content:center;
    align-items:center;
    &>div{
        background-color:${props => props.$backgroundcolor ? props.$backgroundcolor : "var(--bg)"};
        border-radius:10rem;
        &>svg{
            opacity:0.5;
            width:1rem;
            height:1rem;
        }
    }
    :hover{
        &>div{
            // margin-top:0.5rem;
            // display:inherit;
            &>svg{
                opacity:1;
                width:1.2rem;
                height:1.2rem;
            }
        }
    }
`;





const ACTIONS_AT_THIS_STOP = ({taskList, setTasks, spaceOnRight, gap, calc2, calc3, orderNumber, actions, onSite, truckId, noAddButton, backgroundColor, showTooltip}) => {
    let firstNonCompletedActionIndex = null;
    const addTask = (index) => {
        
        AddNewTaskMethod(taskList, setTasks, truckId, orderNumber+index, null);
    }
    
    return <>
        {!noAddButton?
            <AddNewTaskButton  $width={`calc(${gap})`} $right={`calc(${calc2})`} $backgroundcolor={backgroundColor}>
                <AddButton customSize={'1.2rem'} 
                    action={()=>{
                        
                        
                        addTask(1);
                }} />
            </AddNewTaskButton>
        :  
            null  
        }
        
        {actions.map((action, index)=>{
            let customIndex = action.completed ? index - 1 : index;
            const notDispatched = action.dispatchingRequired && !action.dispatched;
            const atTheLocation = (orderNumber === 0 && onSite);
            if(action.completed){
                return null;
            }else{
                if(firstNonCompletedActionIndex === null)firstNonCompletedActionIndex = index;
                return <SingleAction key={index} taskList={taskList} setTasks={setTasks} index={customIndex} spaceOnRight={spaceOnRight} orderNumber={orderNumber} notDispatched={notDispatched} atTheLocation={atTheLocation} action={action} onSite={onSite} truckId={truckId} statusChangableActionIndex = {firstNonCompletedActionIndex} customBackgroundColor={backgroundColor} showTooltip={showTooltip} dispatchingRequired={action.dispatchingRequired} />
            }
        })}
        {
            !noAddButton && orderNumber+taskList.length === taskList.length ? 
            <AddNewTaskButton $width={`calc(${gap})`} $right={`calc(${calc3})`} $backgroundcolor={backgroundColor}>
                <AddButton customSize={'1.2rem'}  action={()=>{
                    addTask(0);
            }} /></AddNewTaskButton>
            : null
        }
    </>
}

export const DiagramView = ({taskList, setTasks, truckId, backgroundColor, showTooltip}) =>{
    
    let totalNumberOfActions = 0;
    if(taskList){
        for(const task of taskList){
        
            for(const action of task.actions){
                if(!action.completed){
                    totalNumberOfActions ++;
                }
            }
            
        }
    }
    
    let actionCountBeforeThis = 0;
    
    return <Wrapper>
        <span className='line'></span>
        {taskList === null || taskList === undefined || taskList.length === 0 ? 
        <AddNewTaskButton  $width={`calc(100%)`} $backgroundcolor={backgroundColor} >
            <AddButton customSize={'1.2rem'}  
                action={()=>{
                    AddNewTaskMethod(taskList, setTasks, truckId, 0, null);
            }} />
        </AddNewTaskButton>
        :
        taskList.map((item, index)=>{
            const task = taskList[taskList.length-1-index];
            const gap = `((100% - ${totalNumberOfActions*3.5}rem)   /${taskList.length+1})`;
            const calc = `calc((${gap}*${index+1}) + (${(actionCountBeforeThis)*3.5}rem) + (${(task.actions.length-1)*3.5}rem))`;
            const calc2 = `calc((${gap}*${index}) + (${(actionCountBeforeThis)*3.5}rem))`;
            const calc3 = `calc((${gap}*${index+1}) + (${(actionCountBeforeThis)*3.5}rem) + (${(totalNumberOfActions-actionCountBeforeThis)*3.5}rem))`;
            actionCountBeforeThis = actionCountBeforeThis + task.actions.length
            return <ACTIONS_AT_THIS_STOP 
                key={index} 
                taskList={taskList} 
                setTasks={setTasks} 
                spaceOnRight={calc}
                gap={gap} 
                calc2={calc2} 
                calc3={calc3} 
                orderNumber={taskList.length-1-index} 
                actions={task.actions} 
                onSite={task.onSite} 
                truckId={truckId} 
                noAddButton={totalNumberOfActions > 10}
                backgroundColor={backgroundColor}
                showTooltip={showTooltip}
            />
        }) }
    </Wrapper>
}

export function stringifyTask(tasks){
    for(let i = 0; i < tasks.length; i++){
        tasks[i] = JSON.stringify(tasks[i])
    }
    return tasks;
}
export function safeParsing(object){
    return typeof(object) === 'string' ? JSON.parse(object): object
}

export function parseTasks(tasksArray, getActiveLoadIds, currentLoadNumber, currentLoadId, currentLoadStops, currentTime, currentLoad){
    const PROVIDED_CURRENT_TIME = typeof currentTime === 'string'
        ? Date.parse(currentTime)
        : (currentTime && typeof currentTime === 'object' && currentTime.current)
            ? currentTime.current.toMillis()
            : (currentTime && typeof currentTime.toMillis === 'function')
                ? currentTime.toMillis()
                : null;
    const loadStopsAndTasksObject = tasksArray && tasksArray.length > 0 ? {
        longTasks: [],
        timeSpecifiedTasks: [],
        timeUnspecifiedTasks: []
    } : {};
    let atHome = false;
    let truckIsOpen = true;
    const activeLoadIds = [];
    let lastLoadsLastTimecode = null;
    let parsedTasks = [];
    if(currentLoadStops && currentLoadStops.length > 2){
        loadStopsAndTasksObject[currentLoadId] = []

        for(let i = 0; i < currentLoadStops.length; i++){
            const currentStop = currentLoadStops[i];
            const timestamp = generateTimestamp(currentStop.apptDate, currentStop.apptTime, currentStop.address, currentLoadStops.length - 1 === i);
            loadStopsAndTasksObject[currentLoadId].push({
                id:`Load${currentLoadNumber}StopIndex${i}`,
                distanceTo : parseInt(currentStop.distanceTo),
                timestamp: timestamp,
            });
        }
        
    }
    if(tasksArray){
        let previousLoadId = null;
        let notDispatchedLoadId = null;
        for (let i = 0; i < tasksArray.length; i++){  
            const prevTaskId = i > 0 ? tasksArray[i-1].id : null;  
            const nextTaskId = i < tasksArray.length-1 ? tasksArray[i+1].id : null;  
            const parsedTask  = tasksArray[i]; 
            
            if(getActiveLoadIds){
                let timeIsSpecified = false;
                if(parsedTask.loadId){
                    previousLoadId = parsedTask.loadId;
                    if(!activeLoadIds.includes(parsedTask.loadId)){
                        activeLoadIds.push(parsedTask.loadId);
                    }
                    const timestamp = generateTimestamp(parsedTask.apptDate, parsedTask.apptTime, parsedTask.address, parsedTask.lastStopOfTheLoad, null, null, null, null, currentLoad, PROVIDED_CURRENT_TIME, parsedTask.loadStopIndex);
                    if(truckIsOpen){
                        if(parsedTask.loadStopIndex > 0){
                            truckIsOpen = false;
                        }else{
                            if(isWithinProvidedHours(PROVIDED_CURRENT_TIME, timestamp, 48)){
                                truckIsOpen = false;
                            }else{
                                truckIsOpen = null; /// no need to check further because truck is OPEN!
                            }
                        }
                    }
                    if(currentLoadId !== parsedTask.loadId){
                        if(!loadStopsAndTasksObject[parsedTask.loadId]){
                            loadStopsAndTasksObject[parsedTask.loadId] = []
                        }
                        loadStopsAndTasksObject[parsedTask.loadId].push({
                            id:parsedTask.id,
                            distanceTo : parseInt(parsedTask.distanceTo),
                            timestamp: timestamp,
                        });
                    }
                    let loadIsDispatched = true;
                    if(parsedTask.loadStopIndex === 0 && parsedTask.actions && parsedTask.actions.length > 0){
                        for(const action of parsedTask.actions){
                            if(action.loadAction){
                                if(!action.dispatched){
                                    loadIsDispatched = false;
                                    notDispatchedLoadId = parsedTask.loadId
                                }
                            }
                        }
                    }
                    if(loadIsDispatched && parsedTask.loadId !== notDispatchedLoadId){
                        lastLoadsLastTimecode = Math.max(lastLoadsLastTimecode, timestamp);
                    }else{
                        lastLoadsLastTimecode += 2;
                    }
                    
                }else{
                    timeIsSpecified = parsedTask["apptDate"] && parsedTask.apptTime ? true : false;
                }
                if(parsedTask.actions && parsedTask.actions.length > 0){
                    let actionsArray = [];
                    let thisIsLongTask = false;
                    let hasUndispatchedAction = false;
                    for(let k = 0; k < parsedTask.actions.length; k++){
                    // for(const action of parsedTask.actions){
                        const action = parsedTask.actions[k];
                        if(!action.loadAction){
                            if(action.completed)continue;
                            hasUndispatchedAction = action.dispatchingRequired && !action.dispatched;
                            
                            const currentAction = {
                                type: action.type,
                                dispatched: action.dispatchingRequired && !action.dispatched ? false : true,
                                desc: action.desc,
                                actionIndex: k
                            }
                            const itIsResetAction = action.type === 'reset';
                            if(action.type === "homeTime" || itIsResetAction){ 
                                thisIsLongTask = true; 
                                if(action.endingTimeType === "Until"){
                                    currentAction.desc = (`Until: ${action.endDate} ${action.endTime || ""}`)+(currentAction.desc ? `\n${currentAction.desc}` : ""); 
                                }else if(action.durationInDays){
                                    currentAction.desc = (action.resetEndETA  ? `Finishes: ${action.resetEndETA}` : `Duration ${action.durationInDays}${itIsResetAction ? ' hours' : ' day(s)'}`) + (currentAction.desc ? `\n${currentAction.desc}` : ""); 
                                }
                                if(parsedTask.apptDate){
                                    const timestamps = generateTimestamp(parsedTask.apptDate, parsedTask.apptTime, parsedTask.address, false, action.durationInDays, itIsResetAction, action.endDate, action.endTime);
                                    if(typeof timestamps === 'object'){
                                        currentAction["startTime"] = timestamps["startTime"];
                                        currentAction["endTime"] = timestamps["endTime"];
                                    }else{
                                        currentAction["startTime"] = timestamps
                                        if(itIsResetAction && action.durationInDays){
                                            currentAction["durationInDays"] = action.durationInDays;
                                        }
                                    }
                                }
                                // else if(action.durationInDays){
                                //     currentAction["durationInDays"] = action.durationInDays;
                                // } 
                                
                                if(action.dispatched && !moreThanADay(PROVIDED_CURRENT_TIME, currentAction)){
                                    if(currentAction["endTime"]){
                                        lastLoadsLastTimecode = currentAction["endTime"]
                                    }else if(currentAction["durationInDays"]){
                                        if(lastLoadsLastTimecode === null){
                                            lastLoadsLastTimecode = PROVIDED_CURRENT_TIME;
                                        }
                                        lastLoadsLastTimecode +=  currentAction["durationInDays"] * (60 * 60 * 1000) * (!itIsResetAction ? 24 : 1);
                                    }else{
                                        lastLoadsLastTimecode = !itIsResetAction ? 9999999999999 : lastLoadsLastTimecode + (34 * 60 * 60 * 1000);
                                    }
                                }                             
                                
                            }
                            
                            
                            actionsArray.push(currentAction)
                        }
                    }
                    if(actionsArray.length > 0){
                        if(truckIsOpen && !thisIsLongTask){
                            if(actionsArray.some(action => action.type === "shop")){
                                if(parsedTask.apptDate){
                                    truckIsOpen = checkIfNextTimeSpecifiedTaskIsWithin24Hours(parsedTask, PROVIDED_CURRENT_TIME);
                                }else if(loadStopsAndTasksObject.timeSpecifiedTasks.length === 0){
                                    truckIsOpen = false;
                                }else{
                                    const lastTimeSpecifiedTask = loadStopsAndTasksObject.timeSpecifiedTasks[loadStopsAndTasksObject.timeSpecifiedTasks.length-1];
                                    truckIsOpen = checkIfNextTimeSpecifiedTaskIsWithin24Hours(lastTimeSpecifiedTask, PROVIDED_CURRENT_TIME);
                                }
                            }
                        }
                        const currentTask = {
                            id: parsedTask.id,
                            onSite: parsedTask.onSite,
                            actionsArray: actionsArray,
                            apptDate: parsedTask.apptDate,
                            apptTime: parsedTask.apptTime,
                            address: parsedTask.address,
                            currentTask: i === 0,
                            hasUndispatchedAction: hasUndispatchedAction
                        }
                        
                        if(prevTaskId){
                            currentTask.taskIdToTheLeft =  prevTaskId;
                        }
                        if(nextTaskId){
                            currentTask.taskIdToTheRight =  nextTaskId;
                        }
                        if(thisIsLongTask){ 
                            if(i === 0 && currentTask.onSite){
                                const homeTimeAction = currentTask.actionsArray[0];
                                const startTime = homeTimeAction.startTime;
                                if(startTime != null){
                                    if(isWithinProvidedHours(PROVIDED_CURRENT_TIME, startTime, 24)){
                                        if(currentTask.actionsArray[0].type === "homeTime"){
                                            atHome = true;
                                        }else{
                                            truckIsOpen = false;
                                        }
                                        
                                    }
                                }
                            }
                            let positionSpecified = true; 
                            if(prevTaskId && !prevTaskId.startsWith("Load")){
                                loadStopsAndTasksObject.timeUnspecifiedTasks = loadStopsAndTasksObject.timeUnspecifiedTasks.map(item => {
                                    if (item.id === prevTaskId) {
                                        positionSpecified = false;
                                        return { ...item, nextTaskIsLongTask: true }; // fixed syntax here
                                    }
                                    return item;
                                });
                                if(positionSpecified){
                                    loadStopsAndTasksObject.longTasks = loadStopsAndTasksObject.longTasks.map(item => {
                                        if (item.id === prevTaskId) {
                                            positionSpecified = false;
                                            return { ...item, nextTaskIsLongTask: true }; // fixed syntax here
                                        }
                                        return item;
                                    });
                                }
                            }           
                            if(previousLoadId){
                                currentTask["previousLoadId"] = previousLoadId;
                            }
                            currentTask["positionSpecified"] = positionSpecified;

                            loadStopsAndTasksObject.longTasks.push(currentTask)
                        }else if(timeIsSpecified){
                            loadStopsAndTasksObject.timeSpecifiedTasks.push(currentTask);
                        }else{
                            lastLoadsLastTimecode += 1;
                            loadStopsAndTasksObject.timeUnspecifiedTasks.push(currentTask);                            
                        }
                    }
                }
            }
            parsedTasks.push(parsedTask);
        }        
    }
    for(const key of  Object.keys(loadStopsAndTasksObject)){
        if(key !== "timeSpecifiedTasks" && key !== "timeUnspecifiedTasks" && key !== "longTasks"){
            const loadData = loadStopsAndTasksObject[key];
            if(loadData && loadData.length > 2){
                const stopsData = [];
                for(let i = 1; i < loadData.length - 1; i++){
                    stopsData.push(getPercentage(loadData[0].timestamp, loadData[loadData.length-1].timestamp, loadData[i].timestamp));
                }
                loadStopsAndTasksObject[key] = stopsData;
            }else if(parseInt(key) !== currentLoadId){
                delete loadStopsAndTasksObject[key];
            }
        }

    }
    return getActiveLoadIds ? {parsedTasks : parsedTasks, activeLoadIds: activeLoadIds, lastLoadsLastTimecode: lastLoadsLastTimecode, loadStopsAndTasksObject: loadStopsAndTasksObject, truckIsAtHome: atHome, truckIsOpen: truckIsOpen !== false} : parsedTasks;
}
function moreThanADay(currentTime, currentAction){
    try {
        return (currentAction["startTime"] - currentTime) > 86400000;
    } catch (error) {
        return false;
    }
}
function isWithinProvidedHours(currentTime, providedTime, numberOfHours){
    if (currentTime == null || providedTime == null) return false;
    return currentTime + (numberOfHours * 60 * 60 * 1000) >= providedTime ;
}
export function generateTimestamp(date, time, address, lastStop, durationInDays, thisIsResetTask, endDate, endTime, currentLoad, currentTimeInMs, loadStopIndex){
    let apptTime = time || "00:00 AM";
    if(apptTime.includes("-")){
        apptTime = apptTime.split("-")[lastStop ? 0 : 0].trim();
    }
    const timeZone = thisIsResetTask ? (localStorage.getItem("defaultTimezone")||"America/Chicago") : (address && address.timezone) ? address.timezone : "America/Chicago" ;
    const startTime = DateTime.fromFormat(`${date} ${apptTime}`, "MM/dd/yy hh:mm a",{ zone: timeZone, locale: "en-US"})
    try {
        if(currentLoad && currentLoad.loadStatus === "InProgress" && lastStop && loadStopIndex + 1 === currentLoad.trucksETA?.stopNumber && currentLoad.trucksETA && !currentLoad.trucksETA.eta.includes("iles away") ){
            return Math.max(startTime.toMillis(),parseTimeStringToMs(currentLoad.trucksETA.eta, currentTimeInMs));
        }
    } catch (error) {
        console.log("couldn't calculate eta timestamp");
    }
    
    
    
    
                   
    if(durationInDays){
        return {
            startTime: startTime.toMillis() ,
            endTime: thisIsResetTask ? startTime.plus({hours: durationInDays || 34}).toMillis() : DateTime.fromFormat(`${date} 00:00 AM`, "MM/dd/yy hh:mm a",{ zone: timeZone, locale: "en-US"}).plus({days: durationInDays}).toMillis()
        }
    }else if(endDate){
        return {
            startTime: startTime.toMillis() ,
            endTime: DateTime.fromFormat(`${endDate} ${endTime || "00:00 AM"}`, "MM/dd/yy hh:mm a",{ zone: timeZone, locale: "en-US"}).toMillis() 
        }
    }
    return startTime.toMillis() ;
}
function getPercentage(startTime, endTime, inbetweenTime) {
    const totalDuration = endTime - startTime;
    const elapsed = inbetweenTime - startTime;
  
    if (totalDuration <= 0) return 0; // Avoid divide by zero or negative duration
    if (inbetweenTime <= startTime) return 0;
    if (inbetweenTime >= endTime) return 100;
    return (elapsed / totalDuration) * 100;
}
export function parseArrayOfStrings(actionsArray){
    if(!actionsArray)return[];
    const ParsedActions = [];
    for (const action of actionsArray){
        ParsedActions.push(safeParsing(action));
        
    }
    return ParsedActions;
}
export function parseLoads(loadsArray){
    if(loadsArray && loadsArray.length > 0 && typeof(loadsArray[0]) === 'string'){
        const parsedVerions = [];
        for(const load of loadsArray){
            parsedVerions.push(JSON.parse(load));
        }
        return parsedVerions;
        
    }
    return loadsArray;
}
function checkIfNextTimeSpecifiedTaskIsWithin24Hours(task, PROVIDED_CURRENT_TIME){
    const timeStamp = generateTimestamp(task.apptDate, task.apptTime, null, false, false, true); // passing null for the address and true for the thisIsResetTask because shop times are set in company's default timezone;
    if(isWithinProvidedHours(PROVIDED_CURRENT_TIME, timeStamp, 24)){
        return false;
    }else{
        return null;
    }
}
const tzMap = {
    PST: "America/Los_Angeles",
    PDT: "America/Los_Angeles",
    MST: "America/Denver",
    MDT: "America/Denver",
    CST: "America/Chicago",
    CDT: "America/Chicago",
    EST: "America/New_York",
    EDT: "America/New_York"
};
export function parseTimeStringToMs(timeStr, baseMs) {
    const baseDate = DateTime.fromMillis(baseMs);
    timeStr = timeStr.replace('~', '');
    // Extract timezone abbreviation
    const match = timeStr.match(/\b([A-Z]{2,3}T)\b/);
    if (!match) throw new Error("Timezone not found in: " + timeStr);

    const abbr = match[1];
    const zone = tzMap[abbr];
    if (!zone) throw new Error("Unsupported timezone abbreviation: " + abbr);

    // Remove abbreviation for parsing, then set zone separately
    const timeWithoutZone = timeStr.replace(abbr, "").trim();

    // Does string include date (MM/dd)?
    const hasDate = /^\d{2}\/\d{2}/.test(timeStr);
    let fullStr;

    if (hasDate) {
        fullStr = `${timeWithoutZone} ${baseDate.year}`;
        return DateTime.fromFormat(fullStr, "MM/dd HH:mm yyyy", { zone }).toMillis();
    } else {
        const datePart = baseDate.toFormat("MM/dd");
        fullStr = `${datePart} ${timeWithoutZone} ${baseDate.year}`;
        return DateTime.fromFormat(fullStr, "MM/dd HH:mm yyyy", { zone }).toMillis();
    }
}